module.exports = __webpack_public_path__ + "media/images/home/netflix-bg-87485521a4493cf316eb51b36d87bfcc.jpg";